import { ModuleManager, SectionList } from "@module-system";

import ShareButton from "./Components/ShareButton.vue";
import CommonConditions from "@lib/commonConditions";
import { ClientJS } from "clientjs";

/**
 * @type {import('@module-system').IModule}
 */
const module = {
  name: "ScreenShare",
  version: "1.0.0",
  register() {

    const screenShareConfig = window.CONFIG?.CALL_BUTTONS?.SCREEN_SHARE ?? {};
    screenShareConfig.ENABLED = screenShareConfig.ENABLED ?? true;
    screenShareConfig.ORDER = screenShareConfig.ORDER ?? 30;

    ModuleManager.addViewModule({
      key: "screen-share-button",
      order: screenShareConfig.ORDER,
      section: SectionList.LocalButtons,
      ViewComponent: ShareButton,
      Condition: (rtcId) => {
        const clientJs = new ClientJS();
        if(clientJs.isMobile()) return false;
        
        const isAgent = CommonConditions.isAgent(rtcId);
        if (isAgent && screenShareConfig.ENABLED.AGENT) return true;
        if (!isAgent && screenShareConfig.ENABLED.USER) return true;
        return false;
      }
    });

  },
};
export default module;